import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  Prescription,
  PrescriptionModeEnum,
} from '../../../../rxc-remote/utils/types/prescriptions';
export type PrescriptionState = {
  view: string;
  selectedTitle: string;
  selectedDescription: string;
  currentPrescription: Prescription | null;
  previousPrescription: Prescription;
  callMyDoctorParams: object;
  uploadFileDataPreview: any;
  isLoadedWithoutEdit: boolean;
  isPrismPriceAdded: boolean;
  currentMode?: PrescriptionModeEnum;
};

const initialState: PrescriptionState = {
  currentPrescription: null,
  previousPrescription: null,
  callMyDoctorParams: null,
  uploadFileDataPreview: null,
  isLoadedWithoutEdit: false,
  isPrismPriceAdded: false,
};

const PrescriptionSlice = createSlice({
  name: 'prescription',
  initialState: initialState,
  reducers: {
    setCurrentPrescription: (
      state,
      { payload }: PayloadAction<Prescription>
    ) => {
      window.rxcBrain.currentPrescription = payload;
      state.currentPrescription = payload;
    },
    setPreviousPrescription: (
      state,
      { payload }: PayloadAction<Prescription>
    ) => {
      state.previousPrescription = payload;
    },
    setCallMyDoctorParams: (state, { payload }: PayloadAction<Object>) => {
      state.callMyDoctorParams = payload;
    },
    setUploadFileDataPreview: (state, { payload }: PayloadAction<Object>) => {
      state.uploadFileDataPreview = payload;
    },
    setLoadedWithoutEdit: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoadedWithoutEdit = payload;
    },
    setIsPrismPriceAdded: (state, { payload }: PayloadAction<boolean>) => {
      window.rxcBrain.isPrismPriceAdded = payload;
      state.isPrismPriceAdded = payload;
    },
    setCurrentMode: (
      state,
      { payload }: PayloadAction<PrescriptionModeEnum>
    ) => {
      state.currentMode = payload;
    },
    reset: (state, { payload }: PayloadAction<string>) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });
    },
  },
});

export const prescriptionReducer = PrescriptionSlice.reducer;
export const prescriptionActions = PrescriptionSlice.actions;
